import { List } from 'antd';
import React from 'react';
import styles from './style.module.scss';

type AppListProps = {
  dataSource: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
  className?: string;
  [key: string]: any;
};

const AppList: React.FC<AppListProps> = ({ dataSource = [], renderItem, className = '', ...rest }) => {
  return (
    <div className={styles['app-list-container']}>
      <List className={className} dataSource={dataSource} renderItem={(item, index) => renderItem(item, index)} {...rest} />
    </div>
  );
};

export default AppList;
